module.exports = __webpack_public_path__ + "img/sand-rock-big-11.89b4fd8e.png";